import { TFunctionNonStrict } from 'i18next';
import type { LevelTableColumn } from 'redesign';
import { TableCell, TableHeader } from 'redesign';

export const getDepartmentsColumnDefinition = (
  t: TFunctionNonStrict<'ogp-screen-specific', undefined>
): Record<'name', LevelTableColumn<{ name: string }>> => {
  return {
    name: {
      accessor: 'name',
      Header: (
        <TableHeader>
          {t('flexpools.departments.table_headers.department_name', { ns: 'ogp-screen-specific' })}
        </TableHeader>
      ),
      Cell: ({ value }) => <TableCell>{value}</TableCell>,
    },
  };
};
